module.exports = __webpack_public_path__ + "static/media/PayLoSignaPay.1bb3bd91.png";